import { useCallback, useLayoutEffect, useRef } from "react";

const styleId = "grabbing-cursor-override";

export const useGrabbingCursor = () => {
  const isGrabbingRef = useRef(false);

  const setCursor = useCallback(() => {
    isGrabbingRef.current = true;
    let styleTag = document.getElementById(styleId) as HTMLStyleElement | null;

    if (!styleTag) {
      styleTag = document.createElement("style");
      styleTag.id = styleId;
      document.head.appendChild(styleTag);
      styleTag.textContent = "* { cursor: grabbing !important; }";
    }
  }, []);

  const resetCursor = useCallback(() => {
    isGrabbingRef.current = false;
    const styleTag = document.getElementById(styleId);
    if (styleTag) {
      styleTag.remove();
    }
  }, []);

  useLayoutEffect(() => {
    return () => {
      const styleTag = document.getElementById(styleId);
      if (styleTag) {
        styleTag.remove();
      }
    };
  }, []);

  useLayoutEffect(() => {
    const handleMouseUp = () => {
      if (isGrabbingRef.current) {
        resetCursor();
      }
    };

    window.addEventListener("mouseup", handleMouseUp);
    return () => window.removeEventListener("mouseup", handleMouseUp);
  }, [resetCursor]);

  return {
    setCursor,
    resetCursor,
  };
};
